export default class Service {
    constructor(title, description, headerImage = "", platforms = []) {
        this.headerImage = headerImage;
        this.title = title;
        this.description = description;
        this.platforms = platforms
    }
}
